import { connect, Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { StyledEngineProvider } from '@mui/material/styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';

import leaflet from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import AppContext from './AppContext';
import routes from './fuse-configs/routesConfig';
import store from './store';
import AclProvider from './providers/acl';
import LoginProvider from './providers/login';
import NotificationsProvider from './providers/notifications';

import 'moment/dist/locale/it';

import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';

// leaflet missing marker icon fix (https://github.com/PaulLeCam/react-leaflet/issues/453)
const DefaultIcon = leaflet.icon({
	iconUrl: icon,
	shadowUrl: iconShadow
});

leaflet.Marker.prototype.options.icon = DefaultIcon;

const ConnectedIntlProvider = connect((state: any) => {
	const { language, messages } = state.i18n;
	return { locale: language, messages };
})(IntlProvider);

const ConnectedLocalizationProvider = connect((state: any) => {
	const { language } = state.i18n;
	return { adapterLocale: language };
})(LocalizationProvider);

const withAppProviders = Component => props => {
	const WrapperComponent = () => (
		<AppContext.Provider value={{ routes }}>
			<Provider store={store}>
				{/* Note that onError is not the best way to prevent that error message. Instead use the messages object to provide default translations */}
				<ConnectedIntlProvider onError={() => {}}>
					<ConnectedLocalizationProvider dateAdapter={AdapterMoment}>
						<StyledEngineProvider injectFirst>
							<NotificationsProvider>
								<LoginProvider>
									<AclProvider>
										<Component {...props} />
									</AclProvider>
								</LoginProvider>
							</NotificationsProvider>
						</StyledEngineProvider>
					</ConnectedLocalizationProvider>
				</ConnectedIntlProvider>
			</Provider>
		</AppContext.Provider>
	);

	return WrapperComponent;
};

export default withAppProviders;
